import React from 'react';

// boundariedChunkedArray
// TODO: possible improvement of further spliting if
// the chunk length is greater thank maxChunkLength
const boundariedChunkedArray = (maxChunkLength) => (collection) => {
  let chunkIndices = collection.reduce((indices, item, index) => {
    item.key.length == 1 ? indices.push(index) : null;
    return indices;
  }, [])

  return chunkIndices.map((idx, i) => {
    return collection.slice(idx, chunkIndices[i+1])
  })
}

const chunkArray = (chunkCount) => (collection) => (
  Math.ceil(collection.length / chunkCount)
).chain(
  chunkSize => Array.from(Array(chunkCount)).map(
    (_, index) => collection.slice(
      (index) * chunkSize, chunkSize * (index + 1)
    )
  )
);

// component with alphabetical list
// A
// Aaab
// Abbb
// Accc
const letterBox = (letter, elements, cb, style = {}) => (
  [
    <span key={letter} className="pt-5 unstyle">
      <b>{letter.toUpperCase()}</b><br/>
    </span>
  ].concat(
    elements.map(
      (element) => (
        <div key={element} className="animated fadeIn">
          <a style={style} className="simple-link" href="#"
              onMouseDown={() => cb(element)}>
            {element}
          </a>
        </div>
      )
    )
  )
);

const letterDict = (collection, cb, style) => collection.sort().reduce(
  (memo, entry) => {
    memo[entry[0].toLowerCase()] ?
      memo[entry[0].toLowerCase()].push(entry) :
      memo[entry[0].toLowerCase()] = [entry];
    return memo;
  }, {}).chain(
    (dict) => Object.keys(dict).map(
      (key) => letterBox(key, dict[key], cb, style)
    ).reduce(
      (memo, e) => memo.concat(e), []
    )
  );

module.exports =  {letterDict, chunkArray, boundariedChunkedArray};



// WEBPACK FOOTER //
// ./components/AutoCompleteList.js